document.addEventListener('DOMContentLoaded', function() {
  const iframe = document.querySelector('.custom-ytb-popup iframe');
  if (iframe) {
    iframe.src = '';
  }

  function handleVideoClick(event) {
    event.preventDefault(); // Prevent default action (navigation)
    event.stopPropagation(); // Stop event from propagating

    const videoLink = event.currentTarget;
    const videoHref = videoLink.getAttribute('href');
    const customPopup = document.querySelector('.custom-ytb-popup');

    if (customPopup) {
      customPopup.classList.add('show');
      if (iframe) {
        iframe.src = videoHref;
      }
    }
  }

  function handleCloseClick(event) {
    const customPopup = event.currentTarget.closest('.custom-ytb-popup');
    if (customPopup) {
      customPopup.classList.remove('show');
      if (iframe) {
        iframe.src = '';
      }
    }
  }

  const videoLinks = document.querySelectorAll('.Video.preview.download');
  videoLinks.forEach(function(videoLink) {
    videoLink.addEventListener('click', handleVideoClick);
  });

  const closeButtons = document.querySelectorAll('.custom-ytb-popup .close');
  closeButtons.forEach(function(closeButton) {
    closeButton.addEventListener('click', handleCloseClick);
  });
});

